import React from 'react';
import PropTypes from 'prop-types';

import {orange500, red500, successColor} from 'assets/jss/main';

ScoreItem.propTypes = {
    value: PropTypes.number,
    label: PropTypes.string
};

function ScoreItem({value, label}) {
    function getScoreColor(score) {
        if (score < 50) return red500;
        if (score < 75) return orange500;

        return successColor;

    }
    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
        }}>
            <span style={{fontSize: '18px', fontWeight: '700', color: getScoreColor(value)}}>
                {value}
            </span>
            <span style={{
                fontSize: '12px',
                color: '#848995',
                textTransform: 'uppercase'
            }}>
                {label}
            </span>
        </div>
    );
}

export default ScoreItem;
